import React from 'react';
import { LevelPricing } from '../components/LevelPricing';
import { CertificationSteps } from '../components/CertificationSteps';
import { TrainingProducts } from '../components/TrainingProducts';
import { PaymentFooter } from '../components/PaymentFooter';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
export function DeveloperExams() {
  return <div className="min-h-screen text-gray-900 font-sans selection:bg-laravel-red selection:text-white" data-id="element-293">
      {/* Header */}
      <div className="bg-gradient-section" data-id="element-294">
        <Header data-id="element-295" />
      </div>

      {/* Hero Section */}
      <div className="bg-white" data-id="element-296">
        <HeroSection data-id="element-297" />
      </div>

      {/* Certification Steps - Gradient */}
      <div className="bg-gradient-section" data-id="element-298">
        <CertificationSteps data-id="element-299" />
      </div>

      {/* Training Products - White */}
      <div className="bg-white" data-id="element-300">
        <TrainingProducts data-id="element-301" />
      </div>

      {/* Level Pricing - Gradient */}
      <div className="bg-gradient-section" data-id="element-302">
        <LevelPricing data-id="element-303" />
      </div>

      {/* Payment Footer - White */}
      <div className="bg-white" data-id="element-304">
        <PaymentFooter data-id="element-305" />
      </div>
    </div>;
}